let url = `http://${window.location.hostname}:8999/`;
// if (process.env.NODE_ENV != "development") {
//     url = `http://qinghua.ninjixiang.cn/`;
// }
export const baseUrl = url;